module.exports = __webpack_public_path__ + "img/ext-link-arrow-dark.d9bd152d.svg";